import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const POSOrderAddPage = () => {
    const [formData, setFormData] = useState({
        pack_unit: '',
        pack_qty: '',
        unit: '',
        quantity: '',
        free_quantity: '',
        rate: '',
        amount: '',
        discount: '',
        taxcode: '',
        taxrate: '',
        taxable: '',
        taxamount: '',
        cess_rate: '',
        cess_amount: '',
        mrp: '',
        net_rate: '',
        remark: '',
        item_barcode: '',
        itembalance: '',
        barcode: '',
        line_level_barcode: '',
        igst: '',
        cgst: '',
        sgst: '',
        hsn_code: '',
        brand: ''
    });

    const navigate = useNavigate();

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Send POST request to the API
        fetch(`${BASE_URL}posorders`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    alert('POS Order created successfully!');
                    navigate('/POSOrderList'); // Redirect to the POS order list page
                } else {
                    alert('Failed to create POS Order.');
                }
            })
            .catch(error => console.error('Error creating POS Order:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add POS Order</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form Section */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">POS Order Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="pack_unit" className="form-label">Pack Unit</label>
                                        <input
                                            type="text"
                                            id="pack_unit"
                                            name="pack_unit"
                                            className="form-control"
                                            value={formData.pack_unit}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="pack_qty" className="form-label">Pack Quantity</label>
                                        <input
                                            type="number"
                                            id="pack_qty"
                                            name="pack_qty"
                                            className="form-control"
                                            value={formData.pack_qty}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="unit" className="form-label">Unit</label>
                                        <input
                                            type="text"
                                            id="unit"
                                            name="unit"
                                            className="form-control"
                                            value={formData.unit}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="quantity" className="form-label">Quantity</label>
                                        <input
                                            type="number"
                                            id="quantity"
                                            name="quantity"
                                            className="form-control"
                                            value={formData.quantity}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="free_quantity" className="form-label">Free Quantity</label>
                                        <input
                                            type="number"
                                            id="free_quantity"
                                            name="free_quantity"
                                            className="form-control"
                                            value={formData.free_quantity}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="rate" className="form-label">Rate</label>
                                        <input
                                            type="number"
                                            id="rate"
                                            name="rate"
                                            className="form-control"
                                            value={formData.rate}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className="form-control"
                                            value={formData.amount}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="remark" className="form-label">Remark</label>
                                        <input
                                            type="text"
                                            id="remark"
                                            name="remark"
                                            className="form-control"
                                            value={formData.remark}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    {/* Add more fields as necessary */}
                                    {/* The other fields can follow similar patterns as the ones above */}

                                    <div className="mb-3 text-end">
                                        <button type="submit" className="btn btn-primary">Save POS Order</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default POSOrderAddPage;
